(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("rxjs"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "rxjs"], factory);
	else if(typeof exports === 'object')
		exports["async-decorator"] = factory(require("react"), require("rxjs"));
	else
		root["async-decorator"] = factory(root["react"], root["rxjs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_rxjs__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/rx6.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/rx-decorator.js":
/*!*****************************!*\
  !*** ./src/rx-decorator.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var disabled = typeof __disableAsyncDecorator === "undefined" ? false : __disableAsyncDecorator; // eslint-disable-line

var inTestingEnv = typeof jasmine !== "undefined";

function _default(React, fromEventPattern) {
  return function MakeAsyncDecorator(DecoratedComponent) {
    var _class, _temp;

    if (disabled) {
      return DecoratedComponent;
    }

    var originalDisplayName = DecoratedComponent.displayName || DecoratedComponent.name;
    return _temp = _class =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(AsyncDecorator, _React$Component);

      // Don't change display name in tests, so that snapshots and wrapper.find('CompName') works.
      // But in browser/non-tests react-dev-tools are easier to understand with a slightly altered display name
      function AsyncDecorator(props) {
        var _this;

        _classCallCheck(this, AsyncDecorator);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(AsyncDecorator).call(this, props));

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "observableCache", {});

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "propEvents", {});

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "propFunctions", []);

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disposables", []);

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", true);

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "stream", function (prop) {
          if (_this.observableCache[prop]) return _this.observableCache[prop];
          _this.observableCache[prop] = fromEventPattern(function (h) {
            if (typeof prop === "function") {
              _this.propFunctions.push([prop, h]);

              setTimeout(function () {
                return h(prop(_this.props));
              });
            } else {
              _this.propEvents[prop] = _toConsumableArray(_this.propEvents[prop]).concat([h]);
              setTimeout(function () {
                return h(_this.props[prop]);
              });
            }
          }, function (h) {});
          return _this.observableCache[prop];
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelWhenUnmounted", function () {
          for (var _len = arguments.length, thingsToCancel = new Array(_len), _key = 0; _key < _len; _key++) {
            thingsToCancel[_key] = arguments[_key];
          }

          if (thingsToCancel.length === 0) {
            throw new Error("cancelWhenUnmounted should be called with one or more cancelables (an object with a dispose, unsubscribe, or cancel function)");
          }

          thingsToCancel.forEach(function (thingToCancel) {
            if (!thingToCancel || typeof thingToCancel.dispose !== "function" && typeof thingToCancel.cancel !== "function" && typeof thingToCancel.unsubscribe !== "function") {
              throw new Error("cancelWhenUnmounted should be called with one or more cancelables (an object with a dispose, unsubscribe, or cancel function)");
            }

            if (_this.mounted) {
              _this.disposables.push(thingToCancel);
            } else {
              // They called cancelWhenUnmounted after the component unmounted...
              cancel(thingToCancel);
            }
          });
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelAllSubscriptions", function () {
          _this.disposables.forEach(function (disposable) {
            cancel(disposable);
          });

          _this.disposables = [];
        });

        return _this;
      }

      _createClass(AsyncDecorator, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          return React.createElement(DecoratedComponent, _extends({}, this.props, {
            ref: function ref(el) {
              return _this2.el = el;
            },
            stream: this.stream,
            cancelWhenUnmounted: this.cancelWhenUnmounted,
            cancelAllSubscriptions: this.cancelAllSubscriptions
          }));
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this3 = this;

          Object.keys(this.propEvents).forEach(function (prop) {
            if (prevProps[prop] !== _this3.props[prop]) {
              _this3.propEvents[prop].forEach(function (event) {
                return event(_this3.props[prop]);
              });
            }
          });
          this.propFunctions.forEach(function (propFunction) {
            var _propFunction = _slicedToArray(propFunction, 2),
                func = _propFunction[0],
                event = _propFunction[1];

            if (func(prevProps) !== func(_this3.props)) {
              event(func(_this3.props));
            }
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.cancelAllSubscriptions();
          this.mounted = false;
        }
      }]);

      return AsyncDecorator;
    }(React.Component), _defineProperty(_class, "displayName", inTestingEnv ? originalDisplayName : "AsyncDecorator(".concat(originalDisplayName, ")")), _temp;
  };
}

function cancel(thing) {
  if (typeof thing.dispose === "function") {
    thing.dispose();
  } else if (typeof thing.unsubscribe === "function") {
    thing.unsubscribe();
  } else if (typeof thing.cancel === "function") {
    thing.cancel();
  } else {// Don't throw an error when we can't cancel the thing they passed in.
  }
}

/***/ }),

/***/ "./src/rx6.js":
/*!********************!*\
  !*** ./src/rx6.js ***!
  \********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(/*! react */ "react"));

var _rxjs = __webpack_require__(/*! rxjs */ "rxjs");

var _rxDecorator = _interopRequireDefault(__webpack_require__(/*! ./rx-decorator.js */ "./src/rx-decorator.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _rxDecorator.default)(_react.default, _rxjs.fromEventPattern);

exports.default = _default;

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "rxjs":
/*!***********************!*\
  !*** external "rxjs" ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_rxjs__;

/***/ })

/******/ });
});
//# sourceMappingURL=rx6.js.map